<template>
  <div class="pro_detail_page" id="pro_detail_page">
    <div class="header">
      <img :src="headerImg" alt="">
    </div>
    <div class="middle">
      <div class="m2_">
        <p class="title">{{insuranceRules.productName}}</p>
      <div class="content">{{insuranceRules.prooductSellPoint}}</div>
      </div>
    </div>
    <div class="content_box">
      <div class="detail">
        <p class="title">保障详情</p>
        <div class="d_" v-for="(item,index) in insuranceLiability" :key="index">
          <div class="dl_">
            <span class="left_">{{item.riskLiability}}</span>
            <div class="right_" @click="showDetail(item,index)" v-if="item.riskDescription || item.sumAssured">
              <span>查看详情</span>
              <span class="arrow_ r_" :class="{'b_': item.expand == true}"></span>
            </div>
          </div>
          <div class="box_" v-if="item.expand">
            <p style="text-align:left;" v-if="item.riskDescription"><span style="font-weight: 500;">险种描述：</span>{{item.riskDescription}}</p>
            <p style="text-align:left;" v-if="item.sumAssured"><span style="font-weight: 500;">险种保额：</span>{{item.sumAssured}}</p>
          </div>
        </div>
      </div>
      <div class="rule" v-if="productClass && productClass==1007">
        <p class="title">投保规则</p>
        <div class="item">
          <span>保险期间</span>
          <span class="r_">{{insuranceRules.insurePeriod}}</span>
        </div>
        <div class="item">
          <span>投保年龄</span>
          <span class="r_">{{insuranceRules.insureAge}}</span>
        </div>
        <div class="item">
          <span>交费期间</span>
          <span class="r_">{{insuranceRules.payPeriod}}</span>
        </div>
        <!-- <div class="item">
          <span>是否双录</span>
          <span class="r_"></span>
        </div> -->
        <div class="item" @click="toExpand" :class="{toUp: expand == true}">
          <span>可销售区域</span>
          <span class="r_" v-if="expand">{{insuranceRules.intermeContractDesc}}</span>
          <span class="r_" v-else>{{insuranceRules.intermeContractDesc | filterWord }}</span>
          <span class="arrow_" :class="{rline_: insuranceRules.intermeContractDesc&&insuranceRules.intermeContractDesc.length >10 && !expand,bline_: expand == true}"></span>
        </div>
      </div>
    </div>
    <div class="tab_list">
      <div class="tab" v-for="(item,index) in tabList" :key="item.value" :class="{active: activeTabIndex == index}" @click="changeTab(index)">
        <div>{{item.name}}</div>
        <span :class="{aline_: activeTabIndex == index}"></span>
      </div>
    </div>
    <div class="material" v-html="materialContent"></div>
    <div class="foot">
      <!-- <span class="type_" @click="showBg=true">投保方式：{{typeArr[0]}}<span class="arrow_"></span></span> -->
      <p class="f_">
        <span class="m1_">¥</span>
        <span class="m2_">{{insuranceRules.price}}</span>
        <span class="unit_">元起</span>
      </p>
      <button class="btn" @click="appointment">预约投保</button>
    </div>
    <div class="fixbg" v-if="showBg" @click.stop="showBg=false">
      <div class="con_">
        <p><span><span>投保方式</span></span></p>
        <div class="list">
          <div class="item_" v-for="(item, index) in typeArr" :key="index">{{item}}</div>
        </div>
      </div>
    </div>
    <div class="mask" v-show="showQrcode" @click.self="showQrcode=false">
      <div class="qrcode">
        <p>长按识别二维码可添加小助手咨询产品</p>
        <img src="../../assets/image/yf/bs_qrcode.png" alt="二维码" v-if="channelSystem=='1'">
        <img src="../../assets/image/yf/mkf_qrcode.png" alt="二维码" v-else>
      </div>
    </div>
    <div class="mask" v-if="showAuthMask">
        <p class="tips">{{msg}}</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.mask {
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.5);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  /deep/ .tab_list img{
    width: 100%;
  }
  .tips{
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    font-size: 14px;
  }
  .qrcode {
    width: 320px;
    height: 270px;
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-sizing: border-box;
    p {
      font-size: 16px;
      margin-bottom: 10px;
    }
    img {
      width: 200px;
    }
  }
}
.pro_detail_page {
  background: #F6F8FA;
  padding-bottom: 2.186667rem;
  .header {
    img {
      width: 100%;
      margin-bottom: 30px;
    }
  }
  .middle {
    position: relative;
    min-height: 2.04rem;
    background: #fff;
    .m2_ {
      position: absolute;
      top: -1rem;
      width: 100%;
      background: #fff;
      border-radius: 0.266667rem;
      padding: 0.533333rem;
      text-align: left;
      .title {
        color: #333;
        font-size: 0.48rem;
        font-weight: 500;
      }
      .content {
        color: #666;
        font-size: 0.346667rem;
        margin-top: 0.213333rem;
        line-height: 0.533333rem;

      }
    }
  }
  .content_box {
    width: 100%;
    background: #fff;
    padding: 16px 16px 12px 20px;
    margin-top: 10px;
    .detail {
      margin-left: 3px;
      color: #333;
      .title {
        position: relative;
        text-align: left;
        display: flex;
        font-size: 15px;
        font-weight: 500;
        margin-bottom: 10px;
        &::before {
          position: absolute;
          left: -7px;
          display: inline-block;
          content: '';
          width: 3px;
          height: 14px;
          border-radius: 2px;
          background: #FF7C6D;
        }
      }
      .d_ {
        display: flex;
        flex-direction: column;
        font-size: 13px;
        margin-top: 10px;
        .dl_ {
          display: flex;
          justify-content: space-between;
          .left_ {
          color: #333;
          text-align:left;
          max-width:80%;
          }
          .right_ {
            color: #ccc;
            display: flex;
            align-items: center;
            .arrow_ {
              display: inline-block;
              width: 0.213333rem;
              height: 0.213333rem;
              transform: rotate(45deg);
              margin-left: 5px;
            }
            .r_ {
              border-top: 1px solid #ccc;
              border-right: 1px solid #ccc;
            }
            .b_ {
              border-top: 0;
              border-bottom: 1px solid #ccc;
              border-right: 1px solid #ccc;
            }
          }
        }
        .box_ {
          margin-top: 10px;
          border-radius: 8px;
          text-align: left;
          background: #F8F8F8;
          padding: 13px 13px 13px 17px;
          line-height: 30px;
        }
      }
    }
    .rule {
      margin:20px 0 0 3px;
      color: #333;
      .title {
        position: relative;
        text-align: left;
        display: flex;
        font-size: 15px;
        font-weight: 500;
        margin-bottom: 10px;
        &::before {
          position: absolute;
          left: -7px;
          display: inline-block;
          content: '';
          width: 3px;
          height: 14px;
          border-radius: 2px;
          background: #FF7C6D;
        }
      }
      .item {
        display: flex;
        justify-content: space-between;
        font-size: 13px;
        color: #333;
        line-height: 19px;
        margin-bottom: 10px;
        &>span:nth-child(1) {
          flex: 3;
          text-align: left;
        }
        &>span:nth-child(2) {
          flex: 7;
          text-align: right;
        }
        .r_ {
          color: #666;
        }
      }
      .toUp {
        align-items: flex-start;
      }
    }
  }
  .tab_list {
    display: flex;
    margin-top: 10px;
    background: #fff;
    height: 45px;
    // margin-bottom: 82px;
    .tab {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      font-size: 14px;
      height: 100%;
      // margin-bottom: 82px;
      &.active {
        color: #FF7C6D;
        font-weight: 500;
      }
      .aline_ {
        position: absolute;
        width: 20px;
        height: 3px;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        background: #FF7C6D;
        border-radius: 2px;
      }
    }
  }
  .material {
    padding: 16px;
    box-sizing: border-box;
    font-size: 13px;
    margin-bottom: 50px;
    text-align: left;
    overflow-x: hidden;
    /deep/ img {
      max-width: 100%;
      height: auto;
    }
    /deep/ strong,
    /deep/ strong span{
      font-weight: bold;
    }
  }
  .foot {
    position: fixed;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 45px;
    background: #fff;
    padding: 0 10px;
    .type_ {
      color: #999;
      font-size: 14px;
      max-width:70%;
      display:flex;
      align-items: center;
      .arrow_{
        width:6px;
        height:10.5px;
        background:url('../../assets/image/bs-2.0/rightgray.png') center center no-repeat;
        background-size:100% 100%;
        display:inline-block;
        transform:none;
      }
    }
    .f_ {
      display: flex;
      align-items: flex-end;
      // justify-content: space-between;
      .m1_ {
        font-size: 13px;
        color: #FF7C6D;
      }
      .m2_ {
        font-size: 20px;
        color: #FF7C6D;
        margin: 0 3px;
      }
      .unit_ {
        font-size: 12px;
        color: #999;
      }
    }
    .btn {
      outline: none;
      border: none;
      width: 100px;
      height: 30px;
      background: #FF7C6D;
      color: #fff;
      border-radius: 20px;
      font-size: 14px;
    }
  }
  .arrow_ {
    display: inline-block;
    width: 0.213333rem;
    height: 0.213333rem;
    transform: rotate(45deg);
    margin-left: 5px;
  }
  .rline_ {
    border-top: 1px solid #ccc;
    border-right: 1px solid #ccc;
  }
  .bline_ {
    border-top: 0;
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
  }
  .fixbg{
    background-color:rgba(0,0,0,0.3);
    position:fixed;
    top:0;
    left:0;
    bottom:0;
    right:0;
    .con_{
      background-color:#fff;
      position:absolute;
      left:0;
      bottom:0;
      right:0;
      border-radius: 15px 15px 0px 0px;
      padding:5px 0 20px;
      p{
        display:flex;
        justify-content: space-between;
        padding:15px  20px;
        font-size:14px;
        >span:last-child{
          position:relative;
          font-weight:bold;
          span{
            z-index:5;
            position:relative;
          }
          &::after{
            background: linear-gradient(45deg, #FF7C6C 0%, #FFA297 100%);
            width:60px;
            height:8px;
            content:'';
            display:block;
            position:absolute;
            bottom:-3px;
            left:0;
            z-index:3;
          }
          
        }
      }
      .list{
        width:90%;
        background-color:#efefef;
        border-radius:15px;
        font-size:13px;
        margin:0 auto;
        padding:5px 0;
        .item_{
          padding:10px 0;
        }
      }
    }
  }
}
</style>

<script>
import api from '@/utils/nsaleApi'
import api2 from "@/utils/api";
import sensorsEvent from '@/utils/sc.js';
export default {
  data() {
    return {
      headerImg: '',
      expand: false,
      channelSystem: '', // 用户所属渠道 1：保思 4：my客蜂
      showQrcode: false,
      tabList: [
        {
          name: '产品详情',
          value: '1',
          materialContent: ''
        },
        {
          name: '投保须知',
          value: '2',
          materialContent: ''
        },
        {
          name: '产品资料',
          value: '3',
          materialContent: ''
        }
      ],
      materialContent: '', // 产品资料
      materialName: '',
      activeTabIndex: 0,
      insuranceRules: {},
      productClass: '', // 产品中类
      insuranceLiability: [],
      productId: '',
      showAuthMask: false,
      msg: '',
      typeList:[
        {
          value:'1',
          text:'PC投保'
        },
        {
          value:'2',
          text:'微链投保'
        },
        {
          value:'3',
          text:'CPS投保'
        },
        {
          value:'4',
          text:'保司微信'
        },
        {
          value:'5',
          text:'保司APP'
        },
        {
          value:'6',
          text:'纸质投保'
        },
      ],
      showBg:false,
      typeArr:[]
    }
  },
  async mounted() {
    this.productId = this.$route.query.productId
    await this.getSearchListItem()
    this.queryUserChannle()
    this.fetchJsSdkSign()
  },
  methods: {
    // 预约投保
    appointment() {
      if(this.productClass == 1007) { // 长险
        this.$router.push({
        path: '/productAppointment',
          query: {
            userId: this.$route.query.userId,
            productCode: this.insuranceRules.productCode,
            productName: this.insuranceRules.productName,
            desc: this.insuranceRules.prooductSellPoint,
            imgUrl: this.headerImg,
            channelSystem: this.channelSystem
          }
        })
        return;
      }
      this.$router.push({ // 短险
        path: '/productAppointmentShort',
        query: {
          userId: this.$route.query.userId,
          productCode: this.insuranceRules.productCode,
          productName: this.insuranceRules.productName,
          desc: this.insuranceRules.prooductSellPoint,
          imgUrl: this.headerImg,
          channelSystem: this.channelSystem
        }
      })
    },
    // 调用风控接口
    verifyState() {
      api.verifyState({
        ruleCode:"20220520332", // 测试code： 20220518789 生产code: 20220520332
        operate:"禁止-访问产品",
        cuswebuserid: this.$route.query.userId,
        productTransactionCode: this.insuranceRules.productCode 
      }).then((res) => {
          let { returnCode, data } = res.data;
          if (returnCode === '0000' && data == '1') { // 状态为1禁止投保
              this.msg = '账号状态异常，暂无该产品访问权限';
              this.showAuthMask = true;
              return;
          }
      })
    },
    toExpand() {
      this.expand = !this.expand
    },
    showDetail(item,index) {
      let expand = !item.expand
      this.$set(this.insuranceLiability[index],'expand',expand)
      this.$forceUpdate()
    },
    changeTab(index) {
      this.activeTabIndex = index
      // if(index === 1) { // 投保须知请求接口
      //   api.getDisclosureInfo(this.insuranceRules.productCode).then(res => res.data).then((res) => {
      //     let { returnCode, returnMsg, data } = res;
			// 		if (returnCode != '0000') {
      //       window.toast({
      //         txt: returnMsg,
      //         type: 'txt'
      //       }).show()
			// 			return;
			// 		}
			// 		if (data.productMaterialDtos && data.productMaterialDtos.length) {
			// 			content = `<div style="padding: 0 20px">${data.productMaterialDtos[0].materialContent}</div>`;
			// 		}
      //     this.materialContent = '' 
      //   })
      //   return
      // }
      this.materialContent = this.tabList[index].materialContent;
      console.log(this.materialContent);
    },
    // jssdk
    fetchJsSdkSign() {
      let url = location.href.split("#")[0];
      let _this = this;
        // alert('获取签名url ->' + url)
        api2.getJsJdkSign2({
          url,
          userId: this.$route.query.userId
        })
        .then(res => res.data)
        .then(async data => {
          if(!data) {
            return
          }
          const { appId, jssdkReqData } = data;
          let options = {
            // debug: true,
            appId: appId, // 必填，公众号的唯一标识
            timestamp: jssdkReqData.timestamp, // 必填，生成签名的时间戳
            nonceStr: jssdkReqData.noncestr, // 必填，生成签名的随机串
            signature: jssdkReqData.signature, // 必填，签名，见附录1
            jsApiList: ["updateTimelineShareData", "updateAppMessageShareData"]
          };
          const { wxShare } = await this.$wx.wxConfig(options)
          let opstion = {
            title: _this.insuranceRules.productName, // 分享标题
            link: window.location.href, // 分享链接
            imgUrl: _this.headerImg ? _this.headerImg : 'https://image.ssish.com/core/material/1666597193879.jpg', // 分享图标
            desc: _this.insuranceRules.prooductSellPoint, // 分享描述
          };
          wxShare(opstion)
        })
      },
    // 查询用户渠道
    queryUserChannle() {
      api.getUserInfoByWebUserId(this.$route.query.userId).then(res => res.data).then((data) => {
        if(data.returnCode !== '0000') {
           window.toast({
            txt: data.returnMsg,
            type: 'txt'
          }).show()
          return;
        }
        console.log(data.data, 602)
        let sensorsData = Object.assign({producCode: this.insuranceRules.productCode, distinct_id: data.data.userId}, data.data);
        sessionStorage.setItem('sensorsData', JSON.stringify(sensorsData));
        sensorsEvent(sensorsData);
        this.channelSystem = data.data.channelSystem;
      })
    },
    /** 过滤产品资料
     * materialType @param Array 产品资料类型
     * list  @param Array 产品资料列表
     */
    filterMaterial(materialTypeList, list) {
        let str = ''
        let arr
        if (list) {
          arr = list.filter((item) => {
            return materialTypeList.indexOf(item.materialType.toString()) > -1 ;
          })
        }
        if (arr.length) {
          arr.forEach((item) => {
            if(item.materialForm == '0') { // 资料类型 0：文件 1：链接 2.文本
              str += `<a style="text-decoration: none !important;line-height: 2;" download="${item.materialName}" href="${item.materialContent}">《${item.materialName}》</a><br/>`;
            }
            if(item.materialForm == '1') {
              str += `<a style="text-decoration: none !important;" href="${item.materialContent}">${item.materialContent}</a><br/>`;
            }
            if(item.materialForm == '2') {
              str += `${item.materialContent}<br/>`;
            }
          })
        }
        return str;
    },
    // 查询产品资料
     queryMaterial() {
      api.getRootProductMaterial({mdProductCode: this.insuranceRules.productCode }).then(res => res.data).then((data) => {
          if(data.returnCode !== '0000') {
            window.toast({
              txt: data.returnMsg,
              type: 'txt'
            }).show()
            return;
          }
          let content = data.data || []
          let materialList = content.filter(item => item.materialType == '5')
          if (materialList && materialList.length > 0) {
            let data = materialList[0]
            localStorage.setItem('materialData',JSON.stringify(data))
          }  else {
            localStorage.setItem('materialData',JSON.stringify({}))
          }
          this.$set(this.tabList[0], 'materialContent', this.filterMaterial(['0'], content));
          this.$set(this.tabList[1], 'materialContent', this.filterMaterial(['5'], content));
          this.$set(this.tabList[2], 'materialContent', this.filterMaterial(['2', '12'], content));
          this.materialContent = this.tabList[0].materialContent
      })
    },
    // 发送邮件
    sendEmail() {
       api.offlineProductSendEmail(
        {
          mdProductCode: this.insuranceRules.productCode,
          webUserId: this.$route.query.userId
        }).then(res => res.data).then((data) => {
          if(data.returnCode !== '0000') {
            window.toast({
              txt: data.returnMsg,
              type: 'txt'
            }).show()
            return;
          }
        })
    },
    getSearchListItem() {
      return new Promise((resolve) => { 
        api.getSearchListItem(this.productId).then(res => res.data).then(data => {
          let content = data.content
          document.title = content.insuranceRules.length && content.insuranceRules[0].productName
          this.insuranceRules = content.insuranceRules.length && content.insuranceRules[0];
          this.productClass = this.insuranceRules.productClass; // productClass:1007为长期险，其他都不是
          if(this.insuranceRules.insureType){
            let arr=this.insuranceRules.insureType.split(',')
            let nameArr=[]
            arr.map(item=>{
                let filter=this.typeList.filter(item1=>item1.value==item)
                if(filter&&filter[0])[
                  nameArr.push(filter[0].text)
                ]
            })
            this.typeArr=nameArr
          }
          this.verifyState();
          this.queryMaterial();
          this.headerImg = this.insuranceRules.productRectanglePicture
          this.insuranceLiability = content.insuranceLiability
          this.insuranceLiability.forEach(item => {
            item.expand = false
          })
          resolve()
        })
      })
    }
  },
  filters: {
    filterWord(value) {
      if (value&&value.length > 10) {
        return value.substr(0,9) + '...'
      } else {
        return value
      }
    },
  },
}
</script>
